import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const PropsTableAsRow = makeShortcode("PropsTableAsRow");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {PageHeader} from '@primer/react/drafts'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Has title only`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.Title>Title</PageHeader.Title>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`Title `}<inlineCode parentName="h3">{`variant="large"`}</inlineCode></h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea variant="large">
    <PageHeader.Title>Title</PageHeader.Title>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`With leading and trailing visuals`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.LeadingVisual>
      <GitPullRequestIcon />
    </PageHeader.LeadingVisual>
    <PageHeader.Title>Title</PageHeader.Title>
    <PageHeader.TrailingVisual>
      <Label>Beta</Label>
    </PageHeader.TrailingVisual>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`With leading visual is hidden on regular viewport`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.LeadingVisual hidden={{regular: true}}>
      <GitPullRequestIcon />
    </PageHeader.LeadingVisual>
    <PageHeader.Title>Title</PageHeader.Title>
    <PageHeader.TrailingVisual>
      <Label>Beta</Label>
    </PageHeader.TrailingVisual>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`With leading and trailing actions`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.LeadingAction>
      <IconButton aria-label="Expand" icon={SidebarExpandIcon} variant="invisible" />
    </PageHeader.LeadingAction>
    <PageHeader.Title>Title</PageHeader.Title>
    <PageHeader.TrailingAction>
      <IconButton aria-label="Edit" icon={PencilIcon} variant="invisible" />
    </PageHeader.TrailingAction>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`With actions`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.Title>Title</PageHeader.Title>
    <PageHeader.Actions>
      <IconButton aria-label="Workflows" icon={WorkflowIcon} />
      <IconButton aria-label="Insights" icon={GraphIcon} />
      <Button variant="primary" trailingIcon={TriangleDownIcon}>
        Add Item
      </Button>
      <IconButton aria-label="Settings" icon={GearIcon} />
    </PageHeader.Actions>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`With description slot`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.Title>add-pageheader-docs</PageHeader.Title>
  </PageHeader.TitleArea>
  <PageHeader.Description>
    <Text sx={{fontSize: 1, color: 'fg.muted'}}>
      <Link href="#" muted sx={{fontWeight: 'bold'}}>
        broccolinisoup
      </Link>{' '}
      created this branch 5 days ago · 14 commits · updated today
    </Text>
  </PageHeader.Description>
</PageHeader>
`}</code></pre>
    <h3>{`With navigation slot`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.Title>Pull request title</PageHeader.Title>
  </PageHeader.TitleArea>
  <PageHeader.Navigation>
    <UnderlineNav2 aria-label="Pull Request">
      <UnderlineNav2.Item icon={CommentDiscussionIcon} counter="12" aria-current="page">
        Conversation
      </UnderlineNav2.Item>
      <UnderlineNav2.Item counter={3} icon={CommitIcon}>
        Commits
      </UnderlineNav2.Item>
      <UnderlineNav2.Item counter={7} icon={ChecklistIcon}>
        Checks
      </UnderlineNav2.Item>
      <UnderlineNav2.Item counter={4} icon={FileDiffIcon}>
        Files Changes
      </UnderlineNav2.Item>
    </UnderlineNav2>
  </PageHeader.Navigation>
</PageHeader>
`}</code></pre>
    <h3>{`With ContextArea`}</h3>
    <h4>{`With parent link and actions (only visible on mobile)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.ContextArea>
    <PageHeader.ParentLink href="http://github.com">Parent Link</PageHeader.ParentLink>

    <PageHeader.ContextAreaActions>
      <Button size="small" leadingIcon={GitBranchIcon}>
        Main
      </Button>
      <IconButton size="small" aria-label="More Options" icon={KebabHorizontalIcon} />
    </PageHeader.ContextAreaActions>
  </PageHeader.ContextArea>
  <PageHeader.TitleArea>
    <PageHeader.Title>Title</PageHeader.Title>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h4>{`With context bar and actions (only visible on mobile)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.ContextArea>
    <PageHeader.ContextBar>
      <Breadcrumbs>
        <Breadcrumbs.Item href="#">...</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">primer</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">react</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">src</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">PageHeader</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">PageHeader.tsx</Breadcrumbs.Item>
      </Breadcrumbs>
    </PageHeader.ContextBar>

    <PageHeader.ContextAreaActions>
      <Button size="small" leadingIcon={GitBranchIcon}>
        Main
      </Button>
      <IconButton size="small" aria-label="More Options" icon={KebabHorizontalIcon} />
    </PageHeader.ContextAreaActions>
  </PageHeader.ContextArea>
  <PageHeader.TitleArea>
    <PageHeader.Title>Title</PageHeader.Title>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h4>{`With a ContextArea with all possible children (always visible)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.ContextArea hidden={false}>
    <PageHeader.ParentLink href="http://github.com" hidden={false}>
      Parent Link
    </PageHeader.ParentLink>

    <PageHeader.ContextBar hidden={false}>
      <Breadcrumbs>
        <Breadcrumbs.Item href="#">...</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">primer</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">react</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">src</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">PageHeader</Breadcrumbs.Item>
        <Breadcrumbs.Item href="#">PageHeader.tsx</Breadcrumbs.Item>
      </Breadcrumbs>
    </PageHeader.ContextBar>

    <PageHeader.ContextAreaActions hidden={false}>
      <Button size="small" leadingIcon={GitBranchIcon}>
        Main
      </Button>
      <IconButton size="small" aria-label="More Options" icon={KebabHorizontalIcon} />
    </PageHeader.ContextAreaActions>
  </PageHeader.ContextArea>
  <PageHeader.TitleArea>
    <PageHeader.Title>Title</PageHeader.Title>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h3>{`With actions that have responsive content`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<PageHeader>
  <PageHeader.TitleArea>
    <PageHeader.Title as="h2">Webhooks</PageHeader.Title>
    <PageHeader.Actions>
      <Hidden on={['narrow']}>
        <Button variant="primary">New webhook</Button>
      </Hidden>
      <Hidden on={['regular', 'wide']}>
        <Button variant="primary">New</Button>
      </Hidden>
    </PageHeader.Actions>
  </PageHeader.TitleArea>
</PageHeader>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`PageHeader`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="aria-label" type={`string | undefined`} description="A unique label for the rendered main landmark" mdxType="PropsTableRow" />
  <PropsTableAsRow defaultElementType="header" mdxType="PropsTableAsRow" />
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`PageHeader.ContextArea`}</h3>
    <p>{`ContextArea should be used to provide users contextual information about their navigation journey. It is only visible on narrow viewports by default.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`PageHeader.ContextArea Children`}</h3>
    <h4>{`PageHeader.ParentLink`}</h4>
    <p>{`ParentLink is the default way to let users navigate up in the hierarchy on narrow viewports.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="href" type="string" description="The URL to link to." defaultValue="" mdxType="PropsTableRow" />
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue={`{
    narrow: false
    regular: true
    wide: true
  }`} description="Whether the parent link is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h4>{`PageHeader.ContextBar`}</h4>
    <p>{`ContextBar is a generic slot for any component above the title region. Use it for custom breadcrumbs and other navigation elements instead of ParentLink.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h4>{`PageHeader.ContextAreaActions`}</h4>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`PageHeader.TitleArea`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
  <PropsTableRow name="variant" type={`| 'subtitle'
| 'medium' | 'large'
| {
    narrow?:
      | 'subtitle'
      | 'medium' 
      | 'large'
    regular?:
      | 'subtitle'
      | 'medium' 
      | 'large'
    wide?:
      | 'subtitle'
      | 'medium' 
      | 'large'
  }`} defaultValue="medium" description="Default title (medium) is the most common page title size. Use for static titles in most situations. 
    Large variant should be used for user-generated content such as issues, pull requests, or discussions. 
    Subtitle variant can be used when a PageHeader.Title is already present in the page, such as in a SplitPageLayout." mdxType="PropsTableRow" />
    </PropsTable>
    <h3>{`PageHeader.TitleArea Children`}</h3>
    <h4>{`PageHeader.LeadingAction`}</h4>
    <p>{`Leading actions can be used for local navigation. It is hidden on narrow viewports by default in favor of ParenLink.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h4>{`PageHeader.LeadingVisual`}</h4>
    <p>{`Leading visuals are optional and appear at the start of the title. They can be octicons, avatars, and other custom visuals that fit a small area.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h4>{`PageHeader.Title`}</h4>
    <PropsTable mdxType="PropsTable">
  <PropsTableAsRow defaultElementType="h3" mdxType="PropsTableAsRow" />
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h4>{`PageHeader.TrailingVisual`}</h4>
    <p>{`Trailing visual and trailing text can display auxiliary information. They're placed at the right of the item, and can denote status, privacy details, etc.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h4>{`PageHeader.TrailingAction`}</h4>
    <p>{`Trailing action can display subtler actions aligned directly next to the title.
It is hidden on narrow viewports by default. Replace the trailing action with an item in an overflow button on narow viewports.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h4>{`PageHeader.Actions`}</h4>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`PageHeader.Description`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`PageHeader.Navigation`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: false,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      